export enum SystemAdminPermissions {
  ChSystemAdmin = "ChSystemAdmin",
  ChUsersMang = "ChUsersMang",
  ChSMSControlPanel = "ChSMSControlPanel",
  ChOnlinePortalUsersAccounts = "ChOnlinePortalUsersAccounts",
  ChEmailsLog = "ChEmailsLog",
}
